<template>
  <div ref="slider" class="keen-slider" :class="{ 'one_libary': 1 === libaries.length }">
    <div v-for="(libary, key) in libaries" :key="key" class="keen-slider__slide">
        <ul>
          <li>
            <img :src="libary.fav_image ? libary.fav_image.image_path : require('../assets/img/no-image.jpeg')" class="p-0 w-100 keen-slider__book-img"/>
            <div class="keen-slider__book-title">
              <p v-if="libary.fav_image">{{ libary.fav_image.product.book_info.title }}</p>
            </div>
          </li>
          <li>Kunde: {{ libary.id }}</li>
          <li>Werke: {{ libary.count }}</li>
          <li>Schwerpunkt: {{ libary.main_focus.name }}</li>
          <li>
            Struktur: 
            <template v-for="(icon) in 5">
              <fa-icon v-if="icon <= libary.structure" class="text-warning" :key="icon" :icon="['fas', 'star']" />
              <fa-icon v-else class="text-dark" :key="icon + '_'" :icon="['fas', 'star']" />
            </template>
          </li>
          <li>Verkaufsangebot: {{ libary.price ? libary.price : libary.sum_price }}€</li>
          <li>Getätigtes Investment: {{ libary.sum_price }}€</li>
          <li>Ø Preis: {{ libary.avg_price }}€</li>
          <li>Ø Zustand: {{ libary.avg_condition }}%</li>
          <li>
            <a :href="webappUrl" class="keen-slider__request-btn">
              <button class="keen-slider__request-btn">
                Anfragen 
              </button>
            </a>
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
import "keen-slider/keen-slider.min.css"
import KeenSlider from "keen-slider"
import { webappUrl } from '@/config.js'

export default {
    props: {
        libaries: {
            type: Array,
            default: () => []
        }
    },
    data() {
      return {
        webappUrl
      }
    },
    mounted() {
      const moreThanThree = 3 <= this.libaries.length

      this.slider = new KeenSlider(this.$refs.slider, {
        loop: moreThanThree,
        duration: 800,
        initial: 0,
        centered: 1 === this.libaries.length,
        slidesPerView: 3,
        spacing: 15,
        breakpoints: {
          "(max-width: 768px)": {
            slidesPerView: 1
          },
          "(min-width: 768px)": {
            slidesPerView: 2
          },
          "(min-width: 1200px)": {
            slidesPerView: 3
          },
        },
      })

      setInterval(() => {
        this.slider.next()
      }, 5000)
    },
    beforeDestroy() {
        if (this.slider) this.slider.destroy()
    },
}
</script>

<style lang="scss">
@use '../assets/scss/_variabls' as vars;
.keen-slider {
  &__slide {
    border-radius: 5px;
    padding: 0 5px;
    background: vars.$theme-color--default;
    display: flex;
    justify-content: center;
    height: fit-content;
    ul  {
      font-size: 1.4rem;
      width: 100%;
      color: vars.$theme-color--default;
      li  {
        background: white;
        border-radius: 5px;
        padding: 5px 10px;
        margin: 5px 0;
        position: relative;
        z-index: 5;
        &:last-of-type, &:first-of-type  {
          padding: 0;
        }
        .keen-slider__book-title  {
          position: absolute;
          z-index: 500;
          color: white;
          display: flex;
          background: vars.$theme-color--default;
          display: flex;
          justify-content: center;
          height: auto;
          width: calc(100% - 40px);
          margin: 0 20px;
          bottom: 30px;
          left: 0;
          border-radius: 5px;
        }
      }
    }
  }
  &__book-img  {
    max-height: 250px;
    object-fit: contain;
  }
  &__request-btn  {
    background: vars.$theme-color--default;
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    color: white;
  }
}

.one_libary {
  margin: 0 auto;
  max-width: 100%;
}

@media #{vars.$tablet-up} {
  .one_libary {
    margin: 0 auto;
    max-width: 400px;
  }
}
</style>

